import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from './firebase-config';
import MapComponent from './MapComponent';

function ResultsPage() {
  const location = useLocation();
  const [crimeData, setCrimeData] = useState([]);
  const [initialLocation, setInitialLocation] = useState({ lat: 41.8781, lng: -87.6298 }); // Default to Chicago
  const [loading, setLoading] = useState(true);
//const [email, setEmail] = useState('');

  useEffect(() => {
    const { docId, results } = location.state;
    if (docId) {
      const fetchLocationData = async () => {
        const docRef = doc(db, 'watchList', docId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setInitialLocation({ lat: data.latitude, lng: data.longitude });
        } else {
          console.log("No such document!");
        }
      };
      fetchLocationData();
    }
    if (results) {
      setCrimeData(results);
      setLoading(false);
    }
  }, [location.state]);


  return (
    <div className="container mx-auto px-4">
      <h1 className="text-3xl font-bold text-center my-6">Crime Data Results</h1>
      {loading ? (
        <p className="text-center">Loading data...</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="col-span-1 md:col-span-2 h-96">
            <MapComponent crimeData={crimeData} interactive={false} latitude={initialLocation.lat} longitude={initialLocation.lng} />
          </div>
          <div className="col-span-1">
            <h2 className="text-xl font-semibold mb-2">Crime Occurrences</h2>
            <div className="overflow-auto h-96 bg-white shadow rounded-lg p-4">
              {crimeData.length > 0 ? (
                crimeData.map((crime, index) => (
                  <div key={index} className="mb-4 p-2 hover:bg-gray-100 rounded">
                    <h3 className="text-lg font-semibold">{crime.primary_type}</h3>
                    <p><strong>Occurrences:</strong> {crime.occurrences}</p>
                  </div>
                ))
              ) : (
                <p className="text-center text-gray-500">No crime data available.</p>
              )}
            </div>
            
          </div>
        </div>
      )}
    </div>
  );
}

export default ResultsPage;